<!--
 * @Author: lsr lsr@qq.com
 * @Date: 2022-07-09 11:46:07
 * @LastEditors: lsr lsr@qq.com
 * @LastEditTime: 2022-07-09 14:03:46
 * @FilePath: \YHB_H5\src\pages\download\sysdownload.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div v-if="browser == false" class="download-content">
		<img src="../../assets/jxs-down-bg.png" class="bg"  pointer-events='none'/>
		<div class="download-bottom"><div class="download-btn" type="default" @click="download"><img src="../../assets/download-logo.png"></img>下载吉祥刷APP</div></div>
	</div>
	<div v-else class="download-content"><img @click="browser = false" src="../../assets/jxs-down-close.png" class="bg" /></div>
</template>

<script>
import { downloadApp } from '@/api/index';
// import { Toast } from 'vant';

export default {
	data() {
		return {
			browser: false
		};
	},
	mounted() {
		// this.getisweixing();
	},

	methods: {
		// 判断是否在 微信浏览器
		getisweixing() {
			var wx = window.navigator.userAgent.toLowerCase();
			if (wx.match(/MicroMessenger/i) == 'micromessenger' || wx.match(/Alipay/i) == "alipay") {
				this.browser = true;
				return; // 是微信端
			} else {
				// console.log('不是微信浏览器绘制原生。');
				this.browser = false;
				return;
			}
		},
		// 下载
		async download() {
			await this.getisweixing();
			if (this.browser) {
				// Toast({
				// 	message: '请点击右上角选择在浏览器中打开',
				// 	duration: 3000
				// });
				return;
			}
			downloadApp('JXS').then(res => {
				let u = navigator.userAgent;
				let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
				console.log(res)
				if (isAndroid) {
					window.location.href = res.msg;
				} else {
					window.location.href =`itms-apps://itunes.apple.com/app/id1658718025?mt=8`
				}
			});
		}
	}
};
</script>

<style lang="scss">
.download-content {
	// position: relative;
	// // max-width: 750px;
	// margin: auto;
	// height: 100%;
	// position: relative;
	// max-width: 750px;
	// margin: auto;
	height: 100%;
	max-width: 100%;
}

.bg {
	width: 100%;
	max-width: 100%;
	height: 100%;
	display: block;
	// max-width: 100%;
}
// .download-close {
// 	position: relative;
// 	max-width: 750px;
// 	margin: auto;
// 	.bg {
// 		max-width: 100%;
// 	}
// }
.download-bottom {
	position: absolute;
	top: 83%;
	width: 100%;
	text-align: center;
	padding-bottom: 20px;

	.download-btn {
		width: 83%;
		height: 45px;
		background: #FFFFFF;
		border-radius: 28px 28px 28px 28px;
		opacity: 1;
		margin: auto;
		line-height: 45px;
		font-size: 18px;
		font-weight: 500;
		color: #FF690E;
	}
	img{
		vertical-align: middle;
		margin-right: 10px;
		width: 25px;
		height: 21px;
	}
}
</style>
